module.exports = __webpack_public_path__ + "static/assets/24349f13d4d5ebfa5cb706cd2f8f3e59.png";